let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5ktVa")).then(() => parcelRequire('kZtV9'));